(function() {
    angular
        .module("app")
        .factory("fmPushService", fmPushService)

    fmPushService.$inject = [
        "$rootScope",
        "$timeout",
        "$window",
        "$state",
        "$http",
        "userMessagingService",
        "authenticationService"
    ]

    function fmPushService(
        $rootScope,
        $timeout,
        $window,
        $state,
        $http,
        userMessagingService,
        authenticationService
    ) {
        "use strict"

        // ============================================================================
        // CONFIG
        // ============================================================================
        var CONFIG = {
            WS_HEARTBEAT_MSG: 'heartbeat',
            WS_TIMEOUT_MS: 12000,   // 7000->12000: field reports of heavy iOS WS->SSE downgrades - give slow (cellular) dials more runway before downgrading; matches SSE_TIMEOUT_MS ceiling
            SSE_TIMEOUT_MS: 12000,
            PUBNUB_TIMEOUT_MS: 10000,
            RETRY_DELAYS: [0, 1000, 3000, 7000],   // per-transport retry backoff (ms) before advancing (WS/SSE)
            MAX_RECONNECT_DELAY_MS: 60000,
            HEARTBEAT_INTERVAL_MS: 30000,
            HEARTBEAT_TIMEOUT_MS: 150000,
            SUSPEND_THRESHOLD_MS: 30000,   // hidden longer than this on foreground -> assume OS suspended the socket, refresh

            // Auth / rollout
            ROLLOUT_COOLDOWN_MS: 15 * 60 * 1000,     // after rollout-denied, recheck later
            AUTH_REFRESH_COOLDOWN_MS: 60000,         // throttle refreshUser calls

            // WebSocket close codes for authentication and authorization
            WS_CLOSE_CODES: {
                SERVER_SHUTDOWN: 1001,
                ABNORMAL_CLOSURE: 1006,
                AUTH_MALFORMED: 1007,
                AUTH_EXPIRED: 1008,
                SERVER_OVERLOAD: 1013,
                ROLLOUT_DENIED: 4403
            },

            DEBUG: true
        }

        var TRANSPORTS = {
            WEBSOCKET: 'WEBSOCKET',
            SSE: 'SSE',
            PUBNUB: 'PUBNUB'
        }

        var TRANSPORT_FALLBACK_ORDER = [TRANSPORTS.WEBSOCKET, TRANSPORTS.SSE, TRANSPORTS.PUBNUB]

        var STATE = { DISCONNECTED: "DISCONNECTED", CONNECTING: "CONNECTING", CONNECTED: "CONNECTED" }

        // Failure types for context
        var FAILURE_TYPE = {
            PRE_CONNECT: 'PRE_CONNECT',           // Failed before _onConnected()
            POST_CONNECT: 'POST_CONNECT',         // Dropped after _onConnected()
            AUTH: 'AUTH',                         // Auth codes (1007/1008)
            ROLLOUT_DENIED: 'ROLLOUT_DENIED',     // Code 4403
            HEARTBEAT_TIMEOUT: 'HEARTBEAT_TIMEOUT',
            NOT_CONFIGURED: 'NOT_CONFIGURED',
            CONNECT_TIMEOUT: 'CONNECT_TIMEOUT',
            ABNORMAL_CLOSURE: 'ABNORMAL_CLOSURE',
            SERVER_OVERLOAD: 'SERVER_OVERLOAD',
            SERVER_SHUTDOWN: 'SERVER_SHUTDOWN',
            SSE_PRE_CONNECT: 'SSE_PRE_CONNECT'
        }

        // ============================================================================
        // LOG
        // ============================================================================
        function log(level, component, /*...args*/ ) {
            if (level === "debug" && !CONFIG.DEBUG) {
                return
            }

            var prefix = "[PUSH:" + component + "]"
            var logFunction = console[level] || console.log
            var args = Array.prototype.slice.call(arguments, 2)

            try {
                logFunction.apply(console, [prefix].concat(args))
            } catch (_) {
                // Ignore logging errors
            }
        }

        // ============================================================================
        // MESSAGE HANDLER
        // ============================================================================
        var messageHandler = {
            handle: function(eventData) {
                if (typeof eventData === "string") {
                    try {
                        var parsed = JSON.parse(eventData)
                        var payload =
                            (parsed && parsed.data) ||
                            (parsed && parsed.payload) ||
                            (parsed && parsed.message) ||
                            parsed
                        if (payload) this.process(payload)
                    } catch (error) {
                        log("debug", "MESSAGE", "Skipped non-JSON message")
                    }
                } else {
                    this.process(eventData)
                }
            },

            process: function(notification) {
                log("debug", "MESSAGE", "Processing notification:", notification)

                if (notification.hasOwnProperty("wz") && notification.wz.hasOwnProperty("id")) {

                    $rootScope.$apply(function() {

                        // Notify Watchers
                        $rootScope.pushedWzData = notification

                    })
                }

                var target = {
                    device:   {},
                    deviceID: 0,
                    reload:   false
                }

                if (notification.hasOwnProperty("device") && notification.device.hasOwnProperty("device")) {
                    if (typeof $rootScope.processDevice === "function") {
                        try {
                            $rootScope.processDevice(notification.device)
                        } catch (_) {}
                    }
                    target.device = notification.device
                    target.deviceID = notification.device.device.id
                }

                if (notification.hasOwnProperty("device_id")) {
                    target.deviceID = notification.device_id
                }

                if (notification.hasOwnProperty("reload") && notification.reload) {
                    target.reload = true
                }

                if (notification.hasOwnProperty("success")) {
                    target.success = notification.success
                }

                if (notification.hasOwnProperty("error")) {
                    target.error = notification.error
                }

                if (notification.hasOwnProperty("in_process")) {
                    target.inProcess = notification.in_process
                }

                if (notification.hasOwnProperty("command_type")) {
                    target.commandType = notification.command_type
                }

                if (target.device.hasOwnProperty("device") || target.deviceID > 0) {

                    $rootScope.$apply(function() {

                        $rootScope.pushedData = target

                    })

                } else if (target.reload) {

                    if (target.hasOwnProperty("success")) {

                        $state.go($state.$current, null, { reload: true }).then(function() {
                            userMessagingService.success(target.success)
                        })

                    } else if (target.hasOwnProperty("error")) {

                        $state.go($state.$current, null, { reload: true }).then(function() {
                            userMessagingService.error(target.error)
                        })

                    }

                } else if (target.hasOwnProperty("success")) {

                    userMessagingService.success(target.success)

                } else if (target.hasOwnProperty("error")) {

                    userMessagingService.error(target.error)

                }

                $rootScope.$apply(function() {

                    // Reset
                    $rootScope.pushedData = {
                        device:   {},
                        deviceID: 0,
                        reload:   false
                    }

                    $rootScope.pushedWzData = {
                        wz: {}
                    }
                })
            }
        }

        // ============================================================================
        // METRICS COLLECTOR
        // ============================================================================
        function MetricsCollector() {
            this.sessionId = this._generateSessionId()
            this.endpoint = "/push_connection_metrics"
        }

        MetricsCollector.prototype._generateSessionId = function() {
            return 'sess_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9)
        }

        MetricsCollector.prototype.recordTransition = function(data) {

            var event = {
                customerId: data.customerId,
                sessionId: this.sessionId,
                attemptId: data.attemptId,
                fromTransport: data.fromTransport,
                toTransport: data.toTransport,
                failureType: data.failureType,
                timestamp: new Date().toISOString(),
                userAgent: navigator.userAgent,
                userId: $rootScope.user.id || null,
                closeCode: data.closeCode || null,
                elapsedMs: data.elapsedMs || null,
                retryCount: data.retryCount || 0,
                consecutiveFailures: data.consecutiveFailures || 0,
                wasConnected: data.wasConnected || false
            }

            this._send([event])
        }

        MetricsCollector.prototype._send = function(events) {

            try {
                $http({
                    method: "POST",
                    url: $rootScope.config.apiUrl + this.endpoint,
                    data: { events: events }
                }).then(
                    function() {
                        log("debug", "METRICS", "Sent", events.length, "event(s)")
                    },
                    function(error) {
                        log("debug", "METRICS", "Send failed (ignored):", error)
                    }
                )
            } catch (e) {
                log("debug", "METRICS", "Send failed (ignored):", e)
            }
        }

        MetricsCollector.prototype.reset = function() {
            this.sessionId = this._generateSessionId()
            log("debug", "METRICS", "Session reset, new ID:", this.sessionId)
        }

        // ============================================================================
        // CONNECTION MANAGER (WS -> SSE -> PUBNUB)
        //
        // Transport Fallback Strategy:
        // 1. WebSocket (preferred)
        // 2. Server-Sent Events (SSE) - Fallback for restrictive networks
        // 3. PubNub - Final fallback
        //
        // All connection failure decision logic is centralized in _handleFailure()
        // ============================================================================
        function ConnectionManager() {
            // State
            this.state = STATE.DISCONNECTED
            this.customerId = null
            this.userDisconnected = false

            // Attempt/transport
            this.attemptId = 0
            this.retryCount = 0
            this.consecutiveFailures = 0
            this.connection = null
            this.currentTransport = null    // One of TRANSPORTS.* or null

            this._pn = null
            this._pnListener = null

            // timers
            this.timers = { connect: null, heartbeat: null, retry: null }

            // heartbeat
            this.lastActivityTime = null

            // cooldown
            this.coolDownUntil = 0

            // auth refresh throttle
            this.lastAuthRefreshAt = 0
            this.refreshingAuth = false

            this._signalsSetup = false
            this._connectDebounceTimer = null

            // Metrics
            this.metricsCollector = new MetricsCollector()
            this.connectionStartTime = null
        }

        // ============================================================================
        // PUBLIC API
        // ============================================================================
        ConnectionManager.prototype.initialize = function(customerId) {
            if (!customerId) { log("error", "MANAGER", "No customer ID provided"); return }

            if (this.customerId && this.customerId !== customerId) {
                log("info", "MANAGER", "Customer ID changed, reconnecting")
                this.cleanup()
                this.state = STATE.DISCONNECTED
            }

            this.customerId = customerId
            this.userDisconnected = false
            this._setupBrowserSignals()
            this.connect()
        }

        ConnectionManager.prototype.disconnect = function() {
            log("info", "MANAGER", "User disconnect")
            this.userDisconnected = true
            this.cleanup()
            this.state = STATE.DISCONNECTED
        }

        ConnectionManager.prototype.getState = function() {
            return {
                connected: this.state === STATE.CONNECTED,
                state: this.state,
                transport: this.currentTransport,
                sinceLastActivityMs: this.lastActivityTime ? Math.max(0, Date.now() - this.lastActivityTime) : null,
                cooldownNextCheckMs: Math.max(0, this.coolDownUntil - Date.now())
            }
        }

        // ============================================================================
        // CONNECTION FLOW
        // ============================================================================

        // Helper to safely increment attemptId with overflow protection
        ConnectionManager.prototype._nextAttemptId = function() {
            this.attemptId++
            if (this.attemptId > Number.MAX_SAFE_INTEGER - 1000) {
                log("info", "MANAGER", "AttemptId approaching overflow, resetting")
                this.attemptId = 1
            }
            return this.attemptId
        }

        // Public connect - called on init, customer change, browser online event
        // Resets everything and starts from scratch
        ConnectionManager.prototype.connect = function() {
            log("info", "MANAGER", "Connect - resetting to initial state")
            this._clearAllTimers()
            this._closeConnection()   // tear down any stale/suspended socket before re-dialing
            this._nextAttemptId()
            this.state = STATE.DISCONNECTED
            this.currentTransport = TRANSPORT_FALLBACK_ORDER[0]
            this.retryCount = 0
            this._tryConnect()
        }

        // Internal connection attempt - executes connection with current transport state
        ConnectionManager.prototype._tryConnect = function() {
            if (this.state === STATE.CONNECTING) return
            if (this._hasTimer("connect")) return  // Already connecting
            if (this._hasTimer("retry")) return    // Already scheduled

            var config = $rootScope.config || {}

            // Special cases that force PubNub
            if (config.fmPushEnabled !== true) {
                log("info", "MANAGER", "FM Push disabled - using PubNub")
                this.currentTransport = TRANSPORTS.PUBNUB
                this.retryCount = 0
            } else if (Date.now() < this.coolDownUntil && this.currentTransport !== TRANSPORTS.PUBNUB) {
                log("info", "MANAGER", "FM Push cooldown active - using PubNub")
                this.currentTransport = TRANSPORTS.PUBNUB
                this.retryCount = 0
            }

            var attemptId = this._nextAttemptId()
            var transport = this.currentTransport

            log("info", "MANAGER", "Trying", transport, "(attempt " + (this.retryCount + 1) + ")")

            this.state = STATE.CONNECTING
            this.connectionStartTime = Date.now()

            var timeout = {
                [TRANSPORTS.WEBSOCKET]: CONFIG.WS_TIMEOUT_MS,
                [TRANSPORTS.SSE]: CONFIG.SSE_TIMEOUT_MS,
                [TRANSPORTS.PUBNUB]: CONFIG.PUBNUB_TIMEOUT_MS
            }[transport]

            var self = this
            this._setTimer("connect", function() {
                if (self.attemptId !== attemptId) return
                log("warn", "MANAGER", "Connection timeout")
                self._handleFailure(attemptId, FAILURE_TYPE.CONNECT_TIMEOUT)
            }, timeout)

            // Execute transport-specific connection
            if (transport === TRANSPORTS.WEBSOCKET) this._connectWebSocket(attemptId)
            else if (transport === TRANSPORTS.SSE) this._connectSSE(attemptId)
            else if (transport === TRANSPORTS.PUBNUB) this._connectPubNub(attemptId)
        }

        // ============================================================================
        // CENTRALIZED FAILURE HANDLER
        // ALL connection failure decision logic lives here
        //
        // Decision tree:
        // - AUTH (WS): first failure -> auth refresh (if not in cooldown): success -> retry same transport, fail -> PubNub. Subsequent failure -> PubNub.
        // - ROLLOUT_DENIED (WS|SSE): -> PubNub with 15min cooldown
        // - CONNECT_TIMEOUT / NOT_CONFIGURED: advance to next transport immediately (no retry)
        // - POST_CONNECT / HEARTBEAT_TIMEOUT / ABNORMAL_CLOSURE / SERVER_OVERLOAD / SERVER_SHUTDOWN / PRE_CONNECT (WS):
        //     retry same transport per RETRY_DELAYS, then advance to next once retries are exhausted
        // - SSE_PRE_CONNECT (SSE): first failure -> auth refresh (if not in cooldown): success -> retry same transport, fail -> PubNub. Subsequent failure -> PubNub.
        // ============================================================================
        ConnectionManager.prototype._handleFailure = function(attemptId, failureType, context) {
            if (this.attemptId !== attemptId) return
            if (this.state !== STATE.CONNECTING && this.state !== STATE.CONNECTED) return

            log("info", "HANDLER", "Handling", failureType, "on", this.currentTransport)

            var beforeTransport = this.currentTransport
            var wasConnected = this.state === STATE.CONNECTED
            var elapsedMs = this.connectionStartTime ? Date.now() - this.connectionStartTime : null
            var beforeRetryCount = this.retryCount // snapshot before setting to zero in some cases

            this._clearTimer("connect")
            this._closeConnection()
            this.state = STATE.DISCONNECTED

            // ========================================================================
            // ALL DECISION LOGIC - Single source of truth
            // ========================================================================

            switch(failureType) {

                case FAILURE_TYPE.AUTH: // WS ONLY
                    if (this.retryCount === 0) {
                        log("info", "HANDLER", "Attempting auth refresh")
                        var self = this
                        this.retryCount++
                        this._refreshAuth(
                            // onSuccess - retry same transport
                            function() {
                                log("info", "HANDLER", "Auth refreshed - retrying", self.currentTransport)
                                self._scheduleConnect(0)
                            },
                            // onFailure - skip to PubNub
                            function() {
                                log("warn", "HANDLER", "Auth refresh failed - skipping to PubNub")
                                self.currentTransport = TRANSPORTS.PUBNUB
                                self.retryCount = 0
                                self._scheduleConnect(0)
                            }
                        )
                    } else {
                        log("warn", "HANDLER", "Reconnect failure after auth refresh - skipping to PubNub")
                        this.currentTransport = TRANSPORTS.PUBNUB
                        this.retryCount = 0
                        this._scheduleConnect(0)
                    }
                    break

                case FAILURE_TYPE.ROLLOUT_DENIED: // WS | SSE
                    // Feature rollout denied - skip to PubNub with cooldown
                    log("info", "HANDLER", "Rollout denied - skipping to PubNub")
                    this.coolDownUntil = Date.now() + CONFIG.ROLLOUT_COOLDOWN_MS
                    this.currentTransport = TRANSPORTS.PUBNUB
                    this.retryCount = 0
                    this._scheduleConnect(0)
                    break

                case FAILURE_TYPE.CONNECT_TIMEOUT:   // WS | SSE | PUBNUB
                case FAILURE_TYPE.NOT_CONFIGURED:    // WS | SSE | PUBNUB
                    // advance to next transport (skip retries)
                    log("info", "HANDLER", failureType, "- advancing to next transport")
                    this.retryCount = 0
                    var advancedToStart = this._advanceTransport()
                    if (advancedToStart) {
                        this.consecutiveFailures++
                        var backoff = this._backoffMs()
                        this._scheduleConnect(backoff)
                    } else {
                        this._scheduleConnect(0)
                    }
                    break

                case FAILURE_TYPE.POST_CONNECT:      // WS | SSE
                case FAILURE_TYPE.HEARTBEAT_TIMEOUT: // WS | SSE
                case FAILURE_TYPE.ABNORMAL_CLOSURE: // WS Only
                case FAILURE_TYPE.SERVER_OVERLOAD:  // WS | SSE
                case FAILURE_TYPE.SERVER_SHUTDOWN:  // WS | SSE
                case FAILURE_TYPE.PRE_CONNECT:      // WS | PUBNUB (Special SSE_PRE_CONNECT below)
                    // Retry Transport accounding to retry schedule or advance and try next transport
                    this.retryCount++
                    if (this.retryCount > CONFIG.RETRY_DELAYS.length) {
                        // Exhausted retries for this transport - advance to next
                        log("info", "HANDLER", "Retries exhausted for", this.currentTransport, "- advancing to next transport")
                        var advancedToStart = this._advanceTransport()
                        var backoff = this._backoffMs()
                        if (advancedToStart) {
                            // Completed a full ladder cycle without holding a connection -
                            // escalate backoff (matches the CONNECT_TIMEOUT branch) so repeated
                            // cycling backs off progressively instead of thrashing.
                            this.consecutiveFailures++
                        }
                        this._scheduleConnect(backoff)
                    } else {
                        // Retry current transport with delay
                        var delay = CONFIG.RETRY_DELAYS[this.retryCount - 1]
                        log("info", "HANDLER", "Retrying", this.currentTransport, "in", delay + "ms (attempt " + (this.retryCount + 1) + ")")
                        this._scheduleConnect(delay)
                    }
                    break

                case FAILURE_TYPE.SSE_PRE_CONNECT: // SSE ONLY
                    if (this.retryCount === 0) {
                        // SSE pre-connect failure might be auth issue, try refresh if available
                        log("info", "HANDLER", "Attempting auth refresh")
                        var self = this
                        this.retryCount++

                        this._refreshAuth(
                            // onSuccess - retry same transport
                            function() {
                                log("info", "HANDLER", "Auth refreshed - retrying", self.currentTransport)
                                self._scheduleConnect(0)
                            },
                            // onFailure - skip to PubNub
                            function() {
                                log("warn", "HANDLER", "Auth refresh failed - skipping to PubNub")
                                self.currentTransport = TRANSPORTS.PUBNUB
                                self.retryCount = 0
                                self._scheduleConnect(0)
                            }
                        )
                    } else {
                        log("warn", "HANDLER", "SSE reconnect failure after auth refresh - skipping to PubNub")
                        this.currentTransport = TRANSPORTS.PUBNUB
                        this.retryCount = 0
                        this._scheduleConnect(0)
                    }
                    break

                default:
                    log("error", "HANDLER", "Unknown failure type:", failureType)
                    // fallback - retry with delay
                    this.retryCount++
                    this._scheduleConnect(1000)
            }

            if (beforeTransport !== this.currentTransport) {
                this.metricsCollector.recordTransition({
                    customerId: this.customerId,
                    attemptId: attemptId,
                    fromTransport: beforeTransport,
                    toTransport: this.currentTransport,
                    failureType: failureType,
                    closeCode: context && context.closeCode,
                    wasConnected: wasConnected,
                    elapsedMs: elapsedMs,
                    retryCount: beforeRetryCount,
                    consecutiveFailures: this.consecutiveFailures
                })
            }
        }

        // ============================================================================
        // TRANSPORT CONNECTION METHODS
        // ============================================================================
        ConnectionManager.prototype._connectWebSocket = function(attemptId) {
            var config = $rootScope.config || {}

            if (!config.fmPushWSUrl) {
                log("warn", "WS", "fmPushWSUrl not configured; skipping WS")
                this._nextTick(this._handleFailure.bind(this, attemptId, FAILURE_TYPE.NOT_CONFIGURED))
                return
            }

            var url = config.fmPushWSUrl
            var webSocket

            try {
                webSocket = new $window.WebSocket(url)
            } catch (error) {
                log("error", "WS", "Failed to create WebSocket:", error)
                this._nextTick(this._handleFailure.bind(this, attemptId, FAILURE_TYPE.PRE_CONNECT))
                return
            }

            var self = this

            webSocket.onopen = function() {
                if (self.attemptId !== attemptId) {
                    try {
                        webSocket.close()
                    } catch(_) {
                        // Ignore close errors
                    }
                    return
                }

                log("info", "WS", "Connected")
                self.connection = webSocket
                self.currentTransport = TRANSPORTS.WEBSOCKET
                self._onConnected(attemptId)
            }

            webSocket.onmessage = function(event) {
                if (self.attemptId !== attemptId) return

                self._markAlive()

                if (event.data === CONFIG.WS_HEARTBEAT_MSG) {
                    log("debug", "WS", "Received Heartbeat")
                    return
                }

                self._onMessage(event.data)
            }

            webSocket.onerror = function(error) {
                if (self.attemptId === attemptId) log("error", "WS", "Error:", error)
            }

            webSocket.onclose = function(event) {
                if (self.attemptId !== attemptId) return

                // No close code available
                if (!(event && event.code)) {
                    log("warn", "WS", "Connection closed without code")
                    self._handleFailure(attemptId, FAILURE_TYPE.PRE_CONNECT)
                    return
                }

                var context = { closeCode: event.code }

                switch(event.code) {

                    case CONFIG.WS_CLOSE_CODES.ABNORMAL_CLOSURE:
                        log("warn", "WS", "Connection closed abnormally")
                        self._handleFailure(attemptId, FAILURE_TYPE.ABNORMAL_CLOSURE, context)
                        break

                    case CONFIG.WS_CLOSE_CODES.AUTH_EXPIRED:
                    case CONFIG.WS_CLOSE_CODES.AUTH_MALFORMED:
                        log("warn", "WS", "Auth issue (code " + event.code + ")")
                        self._handleFailure(attemptId, FAILURE_TYPE.AUTH, context)
                        break

                    case CONFIG.WS_CLOSE_CODES.ROLLOUT_DENIED:
                        log("warn", "WS", "Rollout denied (code " + event.code + ")")
                        self._handleFailure(attemptId, FAILURE_TYPE.ROLLOUT_DENIED, context)
                        break

                    case CONFIG.WS_CLOSE_CODES.SERVER_OVERLOAD:
                        log("warn", "WS", "Server Overload")
                        self._handleFailure(attemptId, FAILURE_TYPE.SERVER_OVERLOAD, context)
                        break

                    case CONFIG.WS_CLOSE_CODES.SERVER_SHUTDOWN:
                        log("warn", "WS", "Server Shutdown")
                        self._handleFailure(attemptId, FAILURE_TYPE.SERVER_SHUTDOWN, context)
                        break

                    default:
                        var wasConnected = self.state === STATE.CONNECTED
                        var failureType = wasConnected ? FAILURE_TYPE.POST_CONNECT : FAILURE_TYPE.PRE_CONNECT
                        log("warn", "WS", "Close code " + event.code + " (" + failureType + ")")
                        self._handleFailure(attemptId, failureType, context)

                }
            }
        }

        ConnectionManager.prototype._connectSSE = function(attemptId) {
            var config = $rootScope.config || {}

            if (!config.fmPushSSEUrl) {
                log("warn", "SSE", "fmPushSSEUrl not configured; skipping SSE")
                this._nextTick(this._handleFailure.bind(this, attemptId, FAILURE_TYPE.NOT_CONFIGURED))
                return
            }

            var url = config.fmPushSSEUrl
            var eventSource

            try {
                eventSource = new $window.EventSource(url, { withCredentials: true })
            } catch (error) {
                log("error", "SSE", "Failed to create EventSource:", error)
                this._nextTick(this._handleFailure.bind(this, attemptId, FAILURE_TYPE.PRE_CONNECT))
                return
            }

            var self = this

            eventSource.onopen = function() {
                if (self.attemptId !== attemptId) {
                    try {
                        eventSource.close()
                    } catch(_) {
                        // Ignore close errors
                    }
                    return
                }

                log("info", "SSE", "Connected")
                self.connection = eventSource
                self.currentTransport = TRANSPORTS.SSE
                self._onConnected(attemptId)
            }

            eventSource.onmessage = function(event) {
                if (self.attemptId !== attemptId) return
                self._markAlive()
                self._onMessage(event.data)
            }

            if (eventSource && typeof eventSource.addEventListener === "function") {
                try {
                    eventSource.addEventListener("heartbeat", function() {
                        if (self.attemptId === attemptId) {
                            log("debug", "SSE", "Received Heartbeat")
                            self._markAlive()
                        }
                    })
                } catch(_) {
                    // Ignore addEventListener errors
                }
            }

            eventSource.onerror = function() {
                if (self.attemptId !== attemptId) {
                    return
                }

                // EventSource auto-reconnects on a transient error: readyState drops to
                // CONNECTING and the browser retries on its own. Only a genuinely CLOSED
                // stream is a real failure. While the browser is recovering, do NOT close
                // it and do NOT report a failure - otherwise every transient blip becomes
                // a needless downgrade. The heartbeat watchdog (HEARTBEAT_TIMEOUT) and the
                // connect watchdog (CONNECT_TIMEOUT) are the backstops if flow never resumes.
                if (eventSource.readyState !== $window.EventSource.CLOSED) {
                    log("debug", "SSE", "Transient error - browser auto-reconnecting")
                    return
                }

                var wasConnected = self.state === STATE.CONNECTED

                if (wasConnected) {
                    // Post-connect error on a CLOSED stream - operational issue
                    log("warn", "SSE", "Connection dropped after successful connect")
                    self._handleFailure(attemptId, FAILURE_TYPE.POST_CONNECT)
                } else {
                    // Pre-connect error on a CLOSED stream - auth issue or network issue
                    log("warn", "SSE", "Pre-connect error")
                    self._handleFailure(attemptId, FAILURE_TYPE.SSE_PRE_CONNECT)
                }
            }
        }

        ConnectionManager.prototype._connectPubNub = function(attemptId) {
            if (this.attemptId !== attemptId) return

            // PubNub subscription is disabled (cost migration off the paid service). Do NOT call
            // disconnect() here - that sets userDisconnected, which makes _scheduleConnect and
            // every browser-signal reconnect handler bail, permanently killing realtime for the
            // whole session until a full re-init. Instead cancel the armed connect watchdog and
            // cycle back to the preferred transport so the client recovers on its own.
            var elapsedMs = this.connectionStartTime ? Date.now() - this.connectionStartTime : null
            this._clearTimer("connect")
            this.state = STATE.DISCONNECTED
            this._advanceTransport()   // PUBNUB -> wraps to WEBSOCKET (also resets retryCount)

            // If a rollout cooldown is active we were force-selected onto PubNub without any
            // WS/SSE attempt (see _tryConnect) - this is NOT a failed connection cycle. Wait out
            // the cooldown WITHOUT escalating consecutiveFailures; when it expires the next
            // attempt starts at WEBSOCKET (_tryConnect no longer re-selects PubNub). No metric
            // here: the ROLLOUT_DENIED downgrade onto PubNub was already recorded, and the client
            // was parked on the terminal rung by policy, not by failing WS/SSE.
            var cooldownRemaining = this.coolDownUntil - Date.now()
            if (cooldownRemaining > 0) {
                log("info", "PN", "PubNub disabled during rollout cooldown - waiting " + cooldownRemaining + "ms")
                this._scheduleConnect(cooldownRemaining + 500)
                return
            }

            // Genuine ladder exhaustion (WS and SSE both unreachable): a full ladder cycle failed,
            // so escalate the backoff and retry from the top.
            log("info", "PN", "PubNub disabled - cycling back to preferred transport with backoff")
            this.consecutiveFailures++

            // Emit the PUBNUB->WEBSOCKET climb-back even though PubNub never actually opened. Reaching
            // the (disabled) terminal rung means WS AND SSE both failed this cycle - the migration
            // burn-down signal - and recording it keeps the metric stream comparable to the pre-disable
            // baseline, which logged these climb-backs. Without it the log shows the *->PUBNUB downgrade
            // with no matching climb-back, making clients look stuck on a rung they actually left at once.
            // failureType NOT_CONFIGURED = "PubNub is not a usable transport (disabled)"; the stub opens
            // nothing, so wasConnected=false / closeCode=null.
            this.metricsCollector.recordTransition({
                customerId: this.customerId,
                attemptId: attemptId,
                fromTransport: TRANSPORTS.PUBNUB,
                toTransport: this.currentTransport,
                failureType: FAILURE_TYPE.NOT_CONFIGURED,
                closeCode: null,
                wasConnected: false,
                elapsedMs: elapsedMs,
                retryCount: 0,
                consecutiveFailures: this.consecutiveFailures
            })

            this._scheduleConnect(this._backoffMs())
        }

        ConnectionManager.prototype._connectPubNubDisabled = function(attemptId) {
            var PubNubClass = $window.Pubnub

            var config = $rootScope.config || {}

            log("debug", "PN", "PubNub connection attempt - config check:", {
                PNClass: !!PubNubClass,
                pubNubSubKey: !!config.pubNubSubKey,
                pubNubPrefix: config.pubNubPrefix,
                label: config.label,
                customerId: this.customerId
            })

            if (!PubNubClass || !config.pubNubSubKey || !config.pubNubPrefix || !config.label) {
                log("error", "PN", "PubNub not available or not configured (class, subKey, prefix, label)")
                this._nextTick(this._handleFailure.bind(this, attemptId, FAILURE_TYPE.NOT_CONFIGURED))
                return
            }

            var userId = config.label.replaceAll(" ", "").toUpperCase() + ":C=" + this.customerId
            var channel = config.pubNubPrefix + "-c" + this.customerId
            var subscribeKey = config.pubNubSubKey

            log("debug", "PN", "PubNub connection details:", {
                userId: userId,
                channel: channel,
                subKey: subscribeKey.length > 8 ? subscribeKey.substring(0, 8) + "..." : subscribeKey,
                v: 1
            })

            var pubNubClient

            try {
                pubNubClient = new PubNubClass({
                    userId: userId,
                    subscribeKey: subscribeKey,
                    ssl: true
                })

                this._pn = pubNubClient
            } catch (error) {
                log("error", "PN", "Failed to construct PubNub client:", error)
                this._nextTick(this._handleFailure.bind(this, attemptId, FAILURE_TYPE.PRE_CONNECT))
                return
            }

            var self = this

            var listener = {
                status: function(statusEvent) {
                    log("debug", "PN", "PubNub status event:", statusEvent)
                    if (self.attemptId !== attemptId) {
                        log("debug", "PN", "Ignoring status - attempt ID mismatch")
                        return
                    }
                    if (!statusEvent) return

                    if (statusEvent.operation === "PNSubscribeOperation") {
                        if (statusEvent.category === "PNConnectedCategory") {
                            log("info", "PN", "Successfully connected")
                            self.connection = pubNubClient
                            self.currentTransport = TRANSPORTS.PUBNUB
                            self._onConnected(attemptId)
                        } else if (["PNBadRequestCategory", "PNAccessDeniedCategory", "PNUnknownCategory"].includes(statusEvent.category)) {
                            log("error", "PN", "terminal error", statusEvent)
                            self._handleFailure(attemptId, FAILURE_TYPE.NOT_CONFIGURED)
                        }
                    } else {
                        log("debug", "PN", "Unhandled status:", statusEvent.category)
                    }
                },
                message: function(msg) {
                    if (self.attemptId !== attemptId) {
                        log("debug", "PN", "Ignoring message - attempt ID mismatch")
                        return
                    }
                    if (!msg || typeof msg.message === "undefined") {
                        log("debug", "PN", "Ignoring message - no message property")
                        return
                    }
                    log("info", "PN", "Processing PubNub message:", msg.message)
                    try {
                        messageHandler.handle(msg.message)
                    } catch (e) {
                        log("error", "PN", "Handler error", e)
                    }
                }
            }

            this._pnListener = listener

            log("debug", "PN", "Adding PubNub listeners and subscribing...")
            try {
                pubNubClient.addListener(listener)
                pubNubClient.subscribe({ channels: [channel] })
                log("debug", "PN", "PubNub subscribe call completed")
            } catch (error) {
                log("error", "PN", "Subscribe failed:", error)
                this._nextTick(this._handleFailure.bind(this, attemptId, FAILURE_TYPE.PRE_CONNECT))
                return
            }
        }

        // ============================================================================
        // CONNECTION LIFECYCLE HANDLERS
        // ============================================================================
        ConnectionManager.prototype._onConnected = function(attemptId) {
            if (this.attemptId !== attemptId) return
            if (this.state !== STATE.CONNECTING) return

            this._clearTimer("connect")
            this.state = STATE.CONNECTED
            this.retryCount = 0
            this.consecutiveFailures = 0

            this._markAlive()
            this._startHeartbeat()
            log("info", "MANAGER", "Connection established via", this.currentTransport)
        }

        ConnectionManager.prototype._onMessage = function(data) {
            if (this.state !== STATE.CONNECTED) {
                return
            }

            try {
                messageHandler.handle(data)
            } catch (e) {
                log("error", "MESSAGE", "Handler error", e)
            }
        }

        // ============================================================================
        // HEARTBEAT WATCHDOG
        // ============================================================================
        ConnectionManager.prototype._startHeartbeat = function() {

            var self = this
            function tick() {
                if (self.state !== STATE.CONNECTED) return

                // skip heartbeat for pubnub
                if (self.currentTransport === TRANSPORTS.PUBNUB) {
                    self._setTimer("heartbeat", tick, CONFIG.HEARTBEAT_INTERVAL_MS)
                    return
                }

                // Mobile: while the tab is hidden the OS suspends the socket and freezes timers;
                // the accumulated silence is not a dead connection. Don't trip the watchdog while
                // hidden - just reschedule. Foreground recovery is handled by visibilitychange.
                if (document.hidden) {
                    self._setTimer("heartbeat", tick, CONFIG.HEARTBEAT_INTERVAL_MS)
                    return
                }

                var last = self.lastActivityTime || 0
                var elapsed = Math.max(0, Date.now() - last)
                if (elapsed > CONFIG.HEARTBEAT_TIMEOUT_MS) {
                    log("warn", "HEARTBEAT", "Timeout detected - no activity for " + elapsed + "ms")
                    var attemptId = self.attemptId
                    self._handleFailure(attemptId, FAILURE_TYPE.HEARTBEAT_TIMEOUT)
                    return
                }
                self._setTimer("heartbeat", tick, CONFIG.HEARTBEAT_INTERVAL_MS)
            }
            this._setTimer("heartbeat", tick, CONFIG.HEARTBEAT_INTERVAL_MS)
        }

        ConnectionManager.prototype._markAlive = function() {
            this.lastActivityTime = Math.max(this.lastActivityTime || 0, Date.now())
        }

        // ============================================================================
        // HELPER METHODS
        // ============================================================================

        // Advance to next transport in fallback order
        // Returns true if advancing back to beginning, false otherwise
        ConnectionManager.prototype._advanceTransport = function() {
            var currentIdx = TRANSPORT_FALLBACK_ORDER.indexOf(this.currentTransport)
            var nextIdx = (currentIdx + 1) % TRANSPORT_FALLBACK_ORDER.length
            this.currentTransport = TRANSPORT_FALLBACK_ORDER[nextIdx]
            this.retryCount = 0
            log("info", "HELPER", "Advanced to:", this.currentTransport)
            if (nextIdx === 0) return true
            return false
        }

        // Schedule a connection attempt
        ConnectionManager.prototype._scheduleConnect = function(delay) {
            if (this.userDisconnected) return

            var self = this
            if (delay === 0) {
                this._nextTick(function() {
                    if (!self.userDisconnected) self._tryConnect()
                })
            } else {
                this._setTimer("retry", function() {
                    if (!self.userDisconnected) self._tryConnect()
                }, delay)
            }
        }

        // Attempt to refresh authentication
        ConnectionManager.prototype._refreshAuth = function(onSuccess, onFailure) {

            if (Date.now() - this.lastAuthRefreshAt < CONFIG.AUTH_REFRESH_COOLDOWN_MS) {
                log("info", "AUTH", "Auth cooldown active, skipping Refresh")
                if (onFailure) onFailure()
                    return
            }

            this.refreshingAuth = true
            var self = this

            try {
                authenticationService.refreshUser(
                    function success() {
                        self.lastAuthRefreshAt = Date.now()
                        self.refreshingAuth = false
                        log("info", "AUTH", "Refresh successful")
                        if (onSuccess) onSuccess()
                    },
                    function failure() {
                        self.refreshingAuth = false
                        log("warn", "AUTH", "Refresh failed")
                        if (onFailure) onFailure()
                    }
                )
            } catch (e) {
                this.refreshingAuth = false
                log("error", "AUTH", "Exception during refresh:", e)
                if (onFailure) onFailure()
            }
        }

        ConnectionManager.prototype._backoffMs = function() {
            var base = Math.min(5000 * Math.pow(2, this.consecutiveFailures), CONFIG.MAX_RECONNECT_DELAY_MS)
            var jitter = Math.floor(base * 0.2 * Math.random())
            return base - jitter
        };

        // ============================================================================
        // TIMER HELPERS
        // ============================================================================
        ConnectionManager.prototype._hasTimer = function(which) {
            return !!this.timers[which]
        }

        ConnectionManager.prototype._setTimer = function(which, callback, milliseconds) {
            this._clearTimer(which)
            var self = this
            this.timers[which] = $timeout(function() {
                self.timers[which] = null
                callback()
            }, milliseconds)
        }

        ConnectionManager.prototype._clearTimer = function(which) {
            if (this.timers[which]) {
                $timeout.cancel(this.timers[which])
                this.timers[which] = null
            }
        }

        ConnectionManager.prototype._clearAllTimers = function() {
            this._clearTimer("connect")
            this._clearTimer("heartbeat")
            this._clearTimer("retry")
        }

        // ============================================================================
        // CONNECTION CLEANUP
        // ============================================================================
        ConnectionManager.prototype._closeConnection = function() {
            if (!this.connection && !this._pn) {
                return
            }

            var transport = this.currentTransport
            var c = this.connection

            try {
                if (transport === TRANSPORTS.WEBSOCKET && c) {
                    c.onopen = c.onmessage = c.onerror = c.onclose = null
                    // WebSocket has no native reconnect, so onclose is authoritative and the
                    // shadow state is the failure signal (handled in onclose). Here we only
                    // tear down: close the socket when it is still opening or open; on a
                    // CLOSING/CLOSED socket close() is a no-op, so skip it.
                    if (c.readyState === $window.WebSocket.CONNECTING || c.readyState === $window.WebSocket.OPEN) {
                        try {
                            c.close()
                        } catch (_) {
                            // Ignore close errors
                        }
                    }
                } else if (transport === TRANSPORTS.SSE && c) {
                    c.onopen = c.onmessage = c.onerror = null
                    if (typeof c.close === "function") {
                        try {
                            c.close()
                        } catch(_) {
                            // Ignore close errors
                        }
                    }
                }
            } catch (e) {
                log("error", "MANAGER", "Error closing connection:", e)
            }

            if (this._pn) {
                try {
                    if (this._pnListener) {
                        this._pn.removeListener(this._pnListener)
                    }
                } catch (_) {
                    // Ignore listener removal errors
                }

                try {
                    if (typeof this._pn.unsubscribeAll === "function") {
                        this._pn.unsubscribeAll()
                    }
                } catch (_) {
                    // Ignore unsubscribe errors
                }

                try {
                    if (typeof this._pn.stop === "function") {
                        this._pn.stop()
                    }
                } catch (_) {
                    // Ignore stop errors
                }

                try {
                    if (typeof this._pn.destroy === "function") {
                        this._pn.destroy()
                    }
                } catch (_) {
                    // Ignore destroy errors
                }
            }

            this.connection = null
            this._pn = null
            this._pnListener = null
        }

        ConnectionManager.prototype.cleanup = function() {
            this._clearAllTimers()
            this._closeConnection()

            // Clear debounce timer
            if (this._connectDebounceTimer) {
                $timeout.cancel(this._connectDebounceTimer)
                this._connectDebounceTimer = null
            }

            this.attemptId++
            this.state = STATE.DISCONNECTED
            this.metricsCollector.reset()
        }

        ConnectionManager.prototype._nextTick = function(callback) { $timeout(callback, 0) }

        // Debounced connection to prevent rapid concurrent calls from browser signals
        ConnectionManager.prototype._debouncedConnect = function() {
            if (this._connectDebounceTimer) {
                $timeout.cancel(this._connectDebounceTimer)
            }
            var self = this
            this._connectDebounceTimer = $timeout(function() {
                self._connectDebounceTimer = null
                self.connect()
            }, 100)  // 100ms debounce
        }

        // ============================================================================
        // BROWSER SIGNALS
        // ============================================================================
        ConnectionManager.prototype._setupBrowserSignals = function() {
            if (this._signalsSetup) return
            this._signalsSetup = true

            var self = this

            $window.addEventListener("online", function() {
                if (self.userDisconnected) return
                if (self.state === STATE.CONNECTED) return
                // Don't reconnect if retry/connect already scheduled
                if (self._hasTimer("retry") || self._hasTimer("connect")) return
                log("info", "BROWSER", "Online event - reconnecting")
                self._debouncedConnect()
            })

            document.addEventListener("visibilitychange", function() {
                if (document.hidden) {
                    // Record when we backgrounded so we can distinguish a quick tab switch from a
                    // long OS suspension on return.
                    self._hiddenAt = Date.now()
                    return
                }
                if (self.userDisconnected) return

                var hiddenMs = self._hiddenAt ? Date.now() - self._hiddenAt : 0
                self._hiddenAt = null

                // A long hidden period on mobile means the OS likely suspended/killed the socket.
                // Reset the activity clock so the watchdog doesn't trip on the suspension gap, then
                // proactively refresh from the top - connect() closes the stale socket and restarts
                // at WEBSOCKET, so this is a same-transport refresh, not a downgrade. This recovers
                // immediately instead of waiting up to HEARTBEAT_INTERVAL for the watchdog to fire.
                if (hiddenMs > CONFIG.SUSPEND_THRESHOLD_MS) {
                    self.lastActivityTime = Date.now()
                    if (self._hasTimer("retry") || self._hasTimer("connect")) return
                    log("info", "BROWSER", "Foreground after " + hiddenMs + "ms hidden - refreshing connection")
                    self._debouncedConnect()
                    return
                }

                // Short blip (quick tab switch): keep the connection unless it's actually gone.
                if (self.state === STATE.CONNECTED) return
                if (self._hasTimer("retry") || self._hasTimer("connect")) return
                var stale = Math.max(0, Date.now() - (self.lastActivityTime || 0)) > CONFIG.HEARTBEAT_TIMEOUT_MS
                if (stale) {
                    log("info", "BROWSER", "Visibility changed - reconnecting")
                    self._debouncedConnect()
                }
            })

            $window.addEventListener("beforeunload", this.cleanup.bind(this))
        }

        // ============================================================================
        // SERVICE API
        // ============================================================================
        var manager = new ConnectionManager()

        return {
            /**
             * Initialize the push service connection for a specific customer
             * @param {number|string} customerId - The customer ID to connect for
             */
            initialize: function(customerId) { return manager.initialize(customerId) },

            /**
             * Disconnect the push service and stop all connection attempts
             */
            disconnect: function() { return manager.disconnect() },

            /**
             * Get current connection state and diagnostic information
             * @returns {Object} State object with connection status, transport type, and timing metrics
             */
            _getState: function() { return manager.getState() },

            /**
             * Enable debug logging for troubleshooting connection issues
             */
            _enableDebug: function() { CONFIG.DEBUG = true; log("info", "SERVICE", "Debug logging enabled") },

            /**
             * Disable debug logging
             */
            _disableDebug: function() { CONFIG.DEBUG = false; log("info", "SERVICE", "Debug logging disabled") }
        }
    }
})()
